module.exports = __webpack_public_path__ + "img/marketing.273fd1b6.jpg";